export default {
      id: "icon-status-off-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-status-off",
      toString: function () {
        return this.url;
      }
    }